<template>
  <div class="question-container">

    <div class="main-box">
      <div class="sidebar">

        <div class="header">
          报表列表
          <div class="grow"></div>
          <el-icon>
            <Menu/>
          </el-icon>
        </div>

        <ul>
          <li class="qa-item" v-for="(item,idx) in sidebarLists"
              :class="{'active': item.active}"
              :key="idx"
              @click="handleClickMenu(item)"
          >
            <div class="name">
              <span v-if="item.required" style="color: red !important;">*</span>
              {{ item.name }}
            </div>

            <div class="sub-name">{{ item.subName }}</div>

          </li>
        </ul>
      </div>

      <div class="opera-area question-out-common">
        <component
            :qaType="activeName"
            :current-qa="currentQa"
            :is="queComponent" ref="viewRef"
            @save="taxSave"
            @taxSave="taxSave"
        />
      </div>
    </div>

    <div class="sep-area"></div>

    <div class="bottom-opera" v-if="taxQuestionType == 3 || taxQuestionType == 1">
      合计
      <el-icon style="padding: 0 5px;" color="#666666">
        <Warning/>
      </el-icon>
      <span class="red">{{ pageShowInfo.summary }}</span>元，({{ pageShowInfo.summaryChinese }})

      <div class="grow"></div>
      <el-button
          type="primary"
          @click="submitHandler3">提交
      </el-button>
    </div>

    <div class="bottom-opera" v-if="taxQuestionType == 2 || taxQuestionType == 6">
      实际应补（退）所得税额
      <el-icon style="padding: 0 5px;" color="#666666">
        <Warning/>
      </el-icon>
      <span class="red">{{ pageShowInfo.back }}</span>元，({{ pageShowInfo.backChinese }})

      <div class="grow"></div>

      <el-button
          @click="riskShow">风险提示服务
      </el-button>

      <el-button
          type="primary"
          @click="submitHandler2">提交申报
      </el-button>
    </div>

    <div class="bottom-opera"
         style="justify-content: center;"
         v-if="taxQuestionType == 4">
      <el-button>上一步</el-button>
      <el-button
          type="primary"
          @click="submitHandler3"
      >提交申报</el-button>
    </div>

    <div class="bottom-opera" v-if="taxQuestionType == 5">
      本期应补（退）税额
      <el-icon style="padding: 0 5px;" color="#666666">
        <Warning/>
      </el-icon>
      <span class="red">{{ pageShowInfo.back }}</span>元，({{ pageShowInfo.backChinese }})

      <div class="grow"></div>

      <el-button>取消</el-button>

      <el-button
          type="primary"
          @click="submitHandler3">提交
      </el-button>
    </div>
  </div>
</template>

<script setup lang="jsx">
import taxQuestionManager1 from "../taxQuestionManager1"; // 1.增值税及附加税（小规模纳税人）
import taxQuestionManager2 from "../taxQuestionManager2"; // 2.填报企业所得税（季度）
import taxQuestionManager2V2025 from '../taxQuestionManager2/v2025' // 2.填报企业所得税（季度）--V2025版本
import taxQuestionManager3 from "../taxQuestionManager3"; // 3.填报增值税及附加税（一般纳税人）
import taxQuestionManager4 from "../taxQuestionManager4"; // 4.财务报表
import taxQuestionManager5 from "../taxQuestionManager5"; // 5.企税年度申报
import {$emit, $on} from "vue-happy-bus";
import {ElMessage, ElMessageBox} from "element-plus";
import {toCapitalChinese} from "@/utils/number";
import Big from "big.js";
import {onBeforeUnmount} from "vue";

const props = defineProps({
  currentQa: { // 当前题目信息对象
    required: true,
    type: Object,
  },
})

const taxQuestionType = computed(() => {
  switch (props.currentQa.sonQueType) {
    case '21':
      return 1
    case '22':
    case '26':
      return 2
    case '23':
      return 3
    case '27':
    case '28':
    case '29': // 汇算清缴-财务报表报送
      return 4
    case '201': //汇算清缴-企业所得税年度申报
      return 5
    case '2201':
    case '2601':
      return 6
    default:
      throw new Error('不支持的类型')
  }
})

const views = [taxQuestionManager1, taxQuestionManager2, taxQuestionManager3, taxQuestionManager4, taxQuestionManager5, taxQuestionManager2V2025];
const queComponent = shallowRef(null);
queComponent.value = views[taxQuestionType.value - 1];

const sidebarLists = ref([])
const activeName = ref('1')


onMounted(() => {
  initSidebarList()
  initQueData()
})

onBeforeUnmount(()=>{
  $emit("setQuestionBoard", null)
})


function initSidebarList() {
  if (taxQuestionType.value == 1) {
    sidebarLists.value = [
      {
        name: '主表',
        subName: '增值税及附加税费申报表',
        required: true,
        duration: '2023-10-01 ~ 2023-12-31',
        time: '2024-01-04',
        status: 0,
        key: 'tax11',
        active: true,
      },
      {
        name: '附列资料一',
        subName: '服务、不动产和无形资产扣除项目明细',
        duration: '2023-10-01 ~ 2023-12-31',
        time: '2024-01-04',
        status: 0,
        key: 'tax12',
      },
      {
        name: '附列资料二',
        subName: '附加税费情况表',
        required: true,
        duration: '2023-10-01 ~ 2023-12-31',
        time: '2024-01-04',
        status: 0,
        key: 'tax13',
      },
      {
        name: '增值税减免税明细申报表',
        subName: '增值税减免税明细申报表',
        duration: '2023-10-01 ~ 2023-12-31',
        time: '2024-01-04',
        status: 0,
        key: 'tax14',
      },
    ]
  } else if (taxQuestionType.value == 2 || taxQuestionType.value == 6) {
    sidebarLists.value = [
      {
        name: '《A200000中华人民共和国企业所得税月（季）度预缴纳税申报表（A类）》',
        duration: '2023-10-01 ~ 2023-12-31',
        time: '2024-01-04',
        status: 0,
        key: 'tax21',
        active: true,
      },
      {
        name: '《A201020固定资产加速折旧(扣除)优惠明细表》',
        duration: '2023-10-01 ~ 2023-12-31',
        time: '2024-01-04',
        status: 0,
        key: 'tax22',
      },
      {
        name: taxQuestionType.value == 2 ? '《A202000企业所得税汇总纳税分支机构所得税分配表》' : '《A202000企业所得税汇总纳税总分支机构所得税分配表》',
        duration: '2023-10-01 ~ 2023-12-31',
        time: '2024-01-04',
        status: 0,
        key: 'tax23',
      },
    ]
  } else if (taxQuestionType.value == 3) {
    sidebarLists.value = [
      {
        name: '主表',
        subName: '增值税及附加税费申报表',
        required: true,
        duration: '2023-12-01 ~ 2023-12-31',
        time: '2024-01-04',
        status: 0,
        key: 'tax31',
        active: true,
      },
      {
        name: '附列资料一',
        subName: '本期销售情况明细',
        required: true,
        duration: '2023-12-01 ~ 2023-12-31',
        time: '2024-01-04',
        status: 0,
        key: 'tax32',
      },
      {
        name: '附列资料二',
        subName: '本期进项税额明细',
        required: true,
        duration: '2023-12-01 ~ 2023-12-31',
        time: '2024-01-04',
        status: 0,
        key: 'tax33',
      },
      {
        name: '附列资料三',
        subName: '服务、不动产和无形资产扣除项目明细',
        duration: '2023-12-01 ~ 2023-12-31',
        time: '2024-01-04',
        status: 0,
        key: 'tax34',
      },
      {
        name: '附列资料四',
        subName: '税额抵减情况表',
        duration: '2023-12-01 ~ 2023-12-31',
        time: '2024-01-04',
        status: 0,
        key: 'tax35',
      },
      {
        name: '附列资料五',
        subName: '附加税费情况表',
        required: true,
        duration: '2023-12-01 ~ 2023-12-31',
        time: '2024-01-04',
        status: 0,
        key: 'tax36',
      },
      {
        name: '增值税减免税申报明细表',
        duration: '2023-12-01 ~ 2023-12-31',
        time: '2024-01-04',
        status: 0,
        key: 'tax37',
      },
    ]
  } else if (taxQuestionType.value == 4) {
    sidebarLists.value = [
      {
        name: '资产负债表',
        duration: '2023-12-01 ~ 2023-12-31',
        time: '2024-01-04',
        status: 0,
        key: 'tax41',
        active: true,
      },
      {
        name: props.currentQa.sonQueType == '29' ? '利润表-年度' : '利润表_月季表',
        duration: '2023-12-01 ~ 2023-12-31',
        time: '2024-01-04',
        status: 0,
        key: 'tax42',
      },
    ]
  }  else if (taxQuestionType.value == 5) {
    sidebarLists.value = [
      {
        name: '《封面》',
        duration: '2023-12-01 ~ 2023-12-31',
        time: '2024-01-04',
        status: 0,
        key: 'tax51',
        active: true,
      },
      {
        name: '《A000000企业基础信息表》',
        duration: '2023-12-01 ~ 2023-12-31',
        time: '2024-01-04',
        status: 0,
        key: 'tax52',
      },
      {
        name: '《A100000企业所得税年度纳税申报主表》',
        duration: '2023-12-01 ~ 2023-12-31',
        time: '2024-01-04',
        status: 0,
        key: 'tax53',
      },
      {
        name: '《A105000纳税调整项目明细表》',
        duration: '2023-12-01 ~ 2023-12-31',
        time: '2024-01-04',
        status: 0,
        key: 'tax54',
      },
      {
        name: '《A105050职工薪酬支出及纳税调整明细表》',
        duration: '2023-12-01 ~ 2023-12-31',
        time: '2024-01-04',
        status: 0,
        key: 'tax55',
      },
      {
        name: '《A105060广告费和业务宣传费等跨年度纳税调整明细表》',
        duration: '2023-12-01 ~ 2023-12-31',
        time: '2024-01-04',
        status: 0,
        key: 'tax56',
      },
      {
        name: '《A105070捐赠支出及纳税调整明细表》',
        duration: '2023-12-01 ~ 2023-12-31',
        time: '2024-01-04',
        status: 0,
        key: 'tax57',
      },
      {
        name: '《A105080资产折旧、摊销情况及纳税调整明细表》',
        duration: '2023-12-01 ~ 2023-12-31',
        time: '2024-01-04',
        status: 0,
        key: 'tax58',
      },
      {
        name: '《A105090资产损失税前扣除及纳税调整明细表》',
        duration: '2023-12-01 ~ 2023-12-31',
        time: '2024-01-04',
        status: 0,
        key: 'tax59',
      },
      {
        name: '《A106000企业所得税弥补亏损明细表》',
        duration: '2023-12-01 ~ 2023-12-31',
        time: '2024-01-04',
        status: 0,
        key: 'tax510',
      },
     /* {
        name: '《A107010免税、减计收入及加计扣除优惠明细表》',
        duration: '2023-12-01 ~ 2023-12-31',
        time: '2024-01-04',
        status: 0,
        key: 'tax511',
      },
      {
        name: '《A107040减免所得税优惠明细表》',
        duration: '2023-12-01 ~ 2023-12-31',
        time: '2024-01-04',
        status: 0,
        key: 'tax512',
      },*/
    ]
  }

  activeName.value = sidebarLists.value[0].key // 默认激活第一个表
  $emit("setQuestionBoard", JSON.parse(props.currentQa.answer)[activeName.value]?.desc);
}

function handleClickMenu(item) {
  sidebarLists.value.forEach(it => {
    it.active = it.key == item.key
  })

  if (activeName.value == item.key) {
    return
  }
  nextTick(() => {
    activeName.value = item.key
    $emit("setQuestionBoard", JSON.parse(props.currentQa.answer)[activeName.value]?.desc);
  })
}

// 题目json信息转js对象
const qaData = computed(() => {
  const taxDataAll = props.currentQa?.solution && JSON.parse(props.currentQa.solution) || null
  return taxDataAll == null ? JSON.parse(props.currentQa.answer) : taxDataAll
})

// 页面显示合计的金额
const pageShowInfo = computed(() => {
  let summary = '0.00'
  if (taxQuestionType.value == 3) {
    summary = parseFloatNum(
        new Big(qaData.value.tax31.data.v34x1.value)
            .plus(qaData.value.tax31.data.v39x1.value)
            .plus(qaData.value.tax31.data.v40x1.value)
            .plus(qaData.value.tax31.data.v41x1.value)
    )
  } else if (taxQuestionType.value == 1) {
    summary = parseFloatNum(
        new Big(qaData.value.tax11.data.v22x1.value)
            .plus(qaData.value.tax11.data.v23x1.value)
            .plus(qaData.value.tax11.data.v24x1.value)
            .plus(qaData.value.tax11.data.v25x1.value)
    )
  }

  let back = '0.00'
  if (taxQuestionType.value == 2) {
    back = parseFloatNum(qaData.value.tax21.data.v28x1.value)
  } else if (taxQuestionType.value == 5) {
    back = parseFloatNum(qaData.value.tax53.data.v45x1.value)
  } else if (taxQuestionType.value == 6) {
      back = parseFloatNum(qaData.value.tax21.data.v50x2.value)
  }
  return {
    summary: summary, // 第1、3题取这个
    summaryChinese: toCapitalChinese(summary),
    back, // 第2题、第5题
    backChinese: toCapitalChinese(back),
  }
})


/*
 * 下面是保存和数据处理区。
 */
const viewRef = ref();

const getGrandchildValue = inject('getGrandchildValue');
getGrandchildValue.value.getData = (byUser, params) => {
  if (!Boolean(byUser)) { // 非用户主动保存数据，不触发修改solution。即报税题需用户手动点击保存按钮
    return {}
  }
  const taxDataAll = viewRef.value.taxSave(2);
  if (!taxDataAll) {
      return {}
  }
  taxDataAll.status = params.status // 将暂存、提交按钮的参数带入
  return {
    solution: JSON.stringify(taxDataAll),
  }
}

const emit = defineEmits(['finish'])

// 爷爷组件，保存成功回调
$on('saveQaSuccess', res => {
  const data = JSON.parse(res?.serverData?.solution || "{}")
  if (data.status == 1) { // 提交了，则进入申报成功页面
    emit('finish')
  }
})

// 保存
const taxSave = async () => {
  $emit('exeSaveQa', {status: 0})
};

defineExpose({
  taxSave
})

//第1、3、4、5题提交
function submitHandler3() {
  ElMessageBox.confirm('声明: 此表是根据国家税收法律法规及相关规定填写，本人（单位）确认填报内容真实可靠，完整，并自愿对填报内容承担法律责任。', '信息确认', {
    confirmButtonText: '确认',
    cancelButtonText: '取消',
    type: 'warning',
  })
      .then(() => {
        $emit('exeSaveQa', {status: 1})
      })
      .catch(() => {
      });
}

function submitHandler2() {
  const vnode = <div style="line-height: 22px;">
    <div>为提升您的申报数据质量，税务机关已为您提供税收政策遵从风险提示服务。</div>
    <div>选择 ”风险提示服务“ : 享受税收政策风险扫描服务，提高申报数据质量。</div>
    <div>选择 ”提交申报“ : 跳过风险提示服务，继续申报</div>
  </div>

  ElMessageBox.confirm(vnode, '提示', {
    confirmButtonText: '提交申报',
    cancelButtonText: '风险提示服务',
    distinguishCancelAndClose: true,
    type: '',
  })
      .then(() => {
        ElMessageBox.confirm('声明: 此表是根据国家税收法律法规及相关规定填写，本人（单位）确认填报内容真实可靠，完整，并自愿对填报内容承担法律责任。', '信息确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          distinguishCancelAndClose: true,
          type: 'warning',
        })
            .then(() => {
              $emit('exeSaveQa', {status: 1})
            })
            .catch()
      })
      .catch(action => {
        if (action == 'cancel') {
          riskShow()
        }
      });
}

function riskShow() {
  ElMessage.warning('风险提示服务功能暂未开发')
}

// 初始化本题的数据
function initQueData() {
  nextTick(() => {
    const taxDataAll = props.currentQa?.solution && JSON.parse(props.currentQa.solution) || null
    console.log('报税题onMounted数据', taxDataAll, JSON.parse(props.currentQa.answer))
    viewRef.value.taxInit({
      mode: 1, // 1 做题 2 设置题目 3 查看结果 4 查看答案
      taxDataAll: taxDataAll == null ? JSON.parse(props.currentQa.answer) : taxDataAll, // 只有新建题目不需要传入taxDataAll 修改题目，做题，查看结果都需要传入
    });
  })
}

function parseFloatNum(s, num = 2) {
  try {
    return new Big(s).toFixed(num);
  } catch (e) {
    console.log(e);
  }
}
</script>


<style scoped lang="scss">
.question-container {
  height: calc(100% - 96px); // 减去header部分，计算得出
  background-color: #f5f5f5;

  .main-box {
    padding-top: 10px;
    padding-left: 15px;
    height: calc(100% - 48px - 16px); // 减去底部
    box-sizing: border-box;
    display: flex;

    .sidebar {
      width: 230px;
      height: calc(100% - 2px);
      background-color: #FFFFFF;
      border-radius: 2px;
      border: 1px solid #e7e8ea;

      .header {
        background-color: #4285f4;
        display: flex;
        color: #FFFFFF;
        height: 40px;
        align-items: center;
        padding: 0 15px;
        margin-bottom: 16px;

        .grow {
          flex-grow: 1;
        }
      }

      .qa-item {
        font-size: 12px;
        color: #333333;
        line-height: 20px;
        padding: 12px 0 12px 13px;
        cursor: pointer;

        .sub-name {
          color: silver;
        }

        border-left: 3px solid transparent;

        &.active {
          background-color: rgba(210, 231, 251, 0.3);
          border-left: 3px solid #4285f4;
        }

        &:hover {
          .name {
            color: #4285f4;
          }
        }
      }
    }

    .opera-area {
      margin-left: 15px;
      background-color: #FFFFFF;
      height: 100%;
      width: 0;
      flex-grow: 1;
      border-radius: 2px;
      box-sizing: border-box;
      padding-bottom: 10px;
    }
  }

  .sep-area {
    height: 16px;
    background-color: rgba(233, 233, 233, 0.08);
  }

  .bottom-opera {
    height: 48px;
    box-sizing: border-box;
    padding: 8px 20px;
    display: flex;
    align-items: center;
    font-size: 12px;
    color: #333333;
    background-color: #FFFFFF;
    box-shadow: 0 -2px 5px 0 rgba(6, 13, 97, .102);

    .red {
      color: #ed5353;
      font-size: 20px;
      font-weight: 700;
    }

    .grow {
      flex-grow: 1;
    }
  }
}

@import url(../cmp/commonStyle.scss);
</style>
